module.exports = __webpack_public_path__ + "img/Nature_Biomedical_Engineering_2025.b7d51677.png";